import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, url, image }) => {
    const defaultImage = 'https://www.bodylabbyanamarija.com/Logo.png';
    const baseUrl = 'https://www.bodylabbyanamarija.com';

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={`${baseUrl}${url}`} />

            {/* Open Graph */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={`${baseUrl}${url}`} />
            <meta property="og:image" content={image || defaultImage} />

            {/* Twitter */}
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image || defaultImage} />
        </Helmet>
    );
};

export default SEO;